import React, { useState } from 'react';
import { faqs } from '../../data/blackout';
import { FaqItem } from './FaqItem';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="border-t border-gunmetal/60 bg-carbon py-20 md:py-28" data-id="element-141" data-mp="32pqxtds4yya1">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 md:px-8 lg:grid-cols-12 lg:gap-16" data-id="element-142" data-mp="37pn2lf8nqtqn">
        <div className="lg:col-span-4" data-id="element-143" data-mp="2a1ldgs4zvbaq">
          <h2 className="font-display text-5xl uppercase leading-[0.95] text-bone md:text-7xl" data-id="element-144" data-mp="2a2mxvn7wha54">
            Questions, answered.
          </h2>
          <div className="mt-6 space-y-1 text-base text-steel" data-id="element-145" data-mp="2jziyl6rk4rz4">
            <p data-id="element-146" data-mp="2jxy7jr4gbr60">Still need help?</p>
            <a href="mailto:support@blackoutunit.com" className="block text-bone underline decoration-gunmetal underline-offset-4 transition-colors duration-150 hover:decoration-bone" data-id="element-147" data-mp="2oym7j2anricd">
              support@blackoutunit.com
            </a>
            <a href="tel:+13055550142" className="block text-bone underline decoration-gunmetal underline-offset-4 transition-colors duration-150 hover:decoration-bone" data-id="element-148" data-mp="4ahmgcog3bgh">
              +1 (305) 555-0142
            </a>
          </div>
        </div>

        <div className="border-t border-gunmetal lg:col-span-8" data-id="element-149" data-mp="1ga3p4w3imndr">
          {faqs.map((faq, i) => <FaqItem key={faq.question} id={`faq-${i}`} question={faq.question} answer={faq.answer} open={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-150" data-mp="1bck6zl3p5qgj" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}